import React from "react";
import img1 from "../../../Assets/ISO Certification/img1.png";
import img2 from "../../../Assets/ISO Certification/img2.png";
import img3 from "../../../Assets/ISO Certification/img3.png";

const ISOSpecification13485 = () => {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 p-10">
        {/* right side content  */}
        <div className="w-full text-[#032303] font-medium sm:text-3xl md:font-medium text-md lg:text-3xl xl:text-4xl">
          <h1 className="mb-3">
            <span className="border-b-4 border-[#249742]"> ISO 134</span>
            85:2016 Specifications :
          </h1>

          <div className="py-4 lg:py-8 space-y-2">
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              ISO 13485:2016 can also be used by suppliers or external parties
              that provide product, including quality management system-related
              services to such organizations.
            </p>

            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              Requirements of ISO 13485:2016 are applicable to organizations
              regardless of their size and regardless of their type except where
              explicitly stated. Wherever requirements are specified as applying
              to medical devices, the requirements apply equally to associated
              services as supplied by the organization.
            </p>

            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              The processes required by ISO 13485:2016 that are applicable to
              the organization, but are not performed by the organization, are
              the responsibility of the organization and are accounted for in
              the organization’s quality management system by monitoring,
              maintaining, and controlling the processes.
            </p>
          </div>
        </div>

        {/* left side images  */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex flex-col items-end gap-4 justify-end w-full">
            <div className="w-full lg:w-auto">
              {" "}
              <img src={img1} alt="" className="rounded-lg w-full lg:w-auto" />
            </div>
            <div className="w-full lg:w-auto">
              {" "}
              <img src={img2} alt="" className="rounded-lg w-full lg:w-auto" />
            </div>
          </div>
          <div className="h-full">
            <img src={img3} alt="" className="rounded-lg h-full" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOSpecification13485;
